import { css } from "@linaria/core";
import { color } from "../..";

export const TableWithBorder = css`
  border: 1px solid;
  border-color: ${color.titanium200};
  border-radius: 4px;
`;
